{"OAUTH_CLIENT_ID":"https://rainbow.umm.gay/client-metadata.json","OAUTH_REDIRECT_URL":"https://rainbow.umm.gay/","OAUTH_SCOPE":"atproto transition:generic"}